import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";

const UserResetPasswordDialog = ({ open, username, onClose, onConfirm }) => {
  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
  };

  const primaryButtonSx = {
    backgroundColor: "#f59e0b",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#d97706",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "1.3rem",
          pt: 3,
          pb: 1,
          color: "#1f1f1f",
        }}
      >
        Reset Password
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <LockResetIcon sx={{ fontSize: 40, color: "#f59e0b" }} />
        </Box>

        <Typography
          sx={{
            color: "#444",
            fontSize: "0.95rem",
          }}
        >
          Are you sure you want to reset the password for
        </Typography>

        <Typography
          sx={{
            fontWeight: 700,
            mt: 0.5,
            color: "#223142",
            wordBreak: "break-word",
          }}
        >
          {username}
        </Typography>

        <Typography
          sx={{
            mt: 1,
            color: "#777",
            fontSize: "0.85rem",
          }}
        >
          A new temporary password will be generated for this user.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1.5,
          justifyContent: "center",
          gap: 1.25,
        }}
      >
        <Button onClick={onClose} variant="outlined" sx={secondaryButtonSx}>
          Cancel
        </Button>

        <Button onClick={onConfirm} variant="contained" sx={primaryButtonSx}>
          Reset Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserResetPasswordDialog;